import {useContext} from "react";
import {MQttContext} from "./MqttProvider";

export const useMqtt=()=>{
  return useContext(MQttContext)
}
